import { IamActionTypes, UsersPaginationState, GET_USERS_WITH_GROUPS_SUCCESS, GroupsWithUserPaginationState, GET_USERS_SUCCESS, GET_USERS_OPTIONS_SUCCESS, User } from "./types";

const usersWithGroupsInit: GroupsWithUserPaginationState = {
    data: [],
    total: 0
}
export function usersWithGroups(state = usersWithGroupsInit, action: IamActionTypes) {
    switch (action.type) {
        case GET_USERS_WITH_GROUPS_SUCCESS:
            return action.payload;
        default:
            return state
    }
}
const usersInit: UsersPaginationState = {
    data: [],
    total: 0
}
export function users(state = usersInit, action: IamActionTypes) {
    switch (action.type) {
        case GET_USERS_SUCCESS:
            return action.payload;
        default:
            return state
    }
}

const initialUserOptions: Array<User> = []

export function usersOptions(state = initialUserOptions, action: IamActionTypes) {
    switch (action.type) {
        case GET_USERS_OPTIONS_SUCCESS:
            return action.payload.data;
        default:
            return state
    }
}

